var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog-category-container"},[_c('h2',[_vm._v("文章分类")]),_c('RightList',{attrs:{"list":_vm.list},on:{"select":_vm.handleSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }